import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../../../utils/constants';

interface Props {
  name: string;
  badge?: string | null;
  timeAgo: string;
}

export const Author = ({ name = 'Unknown Author', badge, timeAgo = 'Unknown time' }: Props) => {
  return (
    <div css={authorContainerStyles}>
      <div css={[avatarStyles, { background: '#ff8b00' }]}> {'RK'} </div>
      <div css={authorInfoStyles}>
        <strong css={authorNameStyles}>{name || 'Unknown Author'}</strong>
        {badge && <span css={badgeStyles}>{badge}</span>}
        <span css={timeAgoStyles}>{timeAgo || 'Unknown time'}</span>
      </div>
    </div>
  );
};

const authorContainerStyles = css({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '8px',
  [MOBILE.MEDIA_QUERY]: {
    marginBottom: '6px',
  },
});

const avatarStyles = css({
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 700,
  marginRight: '12px',
  [MOBILE.MEDIA_QUERY]: {
    width: '28px',
    height: '28px',
    marginRight: '10px',
  },
});

const authorInfoStyles = css({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '8px',
  [MOBILE.MEDIA_QUERY]: {
    gap: '6px',
  },
});

const authorNameStyles = css({
  color: token('color.text'),
  fontFamily: 'Charlie Text, sans-serif',
  fontWeight: 600,
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '14px',
  },
});

const badgeStyles = css({
  marginLeft: '8px',
  fontSize: '12px',
  background: token('color.background.neutral'),
  borderRadius: '4px',
  padding: '2px 6px',
  fontWeight: 600,
  color: token('color.text.subtle'),
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '11px',
    padding: '1px 4px',
  },
});

const timeAgoStyles = css({
  marginLeft: '8px',
  color: token('color.text.subtle'),
  fontSize: '12px',
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '11px',
  },
});
